import React from 'react';
import { Avatar, AvatarFallback } from "./ui/avatar";

interface ChefLexAvatarProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function ChefLexAvatar({ size = "md", className = "" }: ChefLexAvatarProps) {
  const sizeClasses = {
    sm: "h-8 w-8 text-sm",
    md: "h-12 w-12 text-lg",
    lg: "h-16 w-16 text-xl"
  };

  return (
    <Avatar className={`${sizeClasses[size]} bg-gradient-to-br from-coral to-sage ${className}`}>
      <AvatarFallback className="bg-gradient-to-br from-coral to-sage text-white font-medium">
        👨‍🍳
      </AvatarFallback>
    </Avatar>
  );
}
